// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"a1f9f631","977":"6124d5d0"}[chunkId] + ".chunk.js";
};